<template>
  <div>
      <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
      </el-col>
    </el-row>

    <el-form
      :model="assistantInfo"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="标题" prop="title">
        <el-input
          v-model="assistantInfo.real_name"
          maxlength="30"
          show-word-limit
          style="width:33%"
        ></el-input>
      </el-form-item>
      <el-form-item label="头像">
        <el-upload
          class="avatar-uploader"
          :action="ossAction"
          :show-file-list="false"
          :http-request="uploadOSSRequest"
          :before-upload="beforeImageUpload"
        >
          <img
            v-if="assistantInfo.avatar"
            :src="assistantInfo.avatar"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="简介" prop="desc">
        <el-input type="textarea" :rows="2" v-model="assistantInfo.desc" style="width:33%"></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input v-model="assistantInfo.sort" style="width:33%"></el-input>
      </el-form-item>


      <el-form-item>
        <el-button
          size="small"
          type="primary"
          @click="
            updateAssistantInfo()
          "
          :loading="updateLoading"
          >确 定</el-button
        >
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import tinymce from '@/components/tinymce.vue';

import {
  beforeImageUpload,
  beforeVideoUpload,
  uploadOSSRequest,
  getAliyunOssToken,
} from "@/api/common";

import {
  updateAssistantInfo,
  getAssistantInfo,
  allMeetStoryList
} from "@/api/assistant";
import { PrefixSource } from "webpack-sources";

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    limit: {
      type: Number,
      default: 9
    },
    fileType: String,
  },
  computed: {
    // ['xxx', 'xxx'] 转换为 [{url: 'xxx'}, {url: 'xxx'}]
    /*fileList() {
      return this.value.map(url => ({
        url
      }))
    }*/
  },
  data: function () {
    return {
      isshow: false,
      ossAction: "",
      ossData: {},
      loading: false,
      aliyunOssToken: "",
      updateLoading: false,
      categoryOptions:[
        {key:1,value:"研习社"},
        {key:2,value:"遇见门票"},
      ],
      meetStoryList:[],
      editor: null,
      assistantInfo: {
        id: 0,
        real_name: "",
        avatar: "",
        desc: "",
        sort: 0,
      },
      UPLOAD_URL: "/v1/admin/common/upload", // 上传的图片服务器地址 即上传图片后台接口的路径
      /*loading: '',*/
      param: {
        token: ''
      },
      dialogImageUrl: "",
      dialogImgVisible: false,
      disabled: false,
      images:[],
      num:0,
      fileNum:0,
      fileList:[]
    };
  },
  components: {
    tinymce,
  },
  created: function () {
    this.assistantInfo.id = this.$route.query.id;
    if (this.assistantInfo.id > 0) {
      this.getInfo();
    }
  },
  mounted() {
  },
  methods: {
    beforeImageUpload(file) {
      beforeImageUpload(file);
    },
    uploadOSSRequest(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.assistantInfo.avatar = fileUrl
        });
      });
    },

    getInfo() {
      this.loading = true;
      getAssistantInfo({
        id: this.assistantInfo.id,
      }).then((response) => {
        this.assistantInfo = response.data;
        this.loading = false;
      });
    },
    updateAssistantInfo() {
      this.updateLoading = true;
      updateAssistantInfo(this.assistantInfo)
        .then((response) => {
          this.updateLoading = false;
          if (response.code == 1) {
            this.$message.success(response.message);
            this.$router.push({
              path: "/assistant/list",
            });

          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },

    ref() {
      window.history.go(-1);
    },

    //*********多图上传添加内容 开始*********

    //多图上传方法
    uploadImagesOSSRequest(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          let imageUrl = fileUrl;
          this.assistantInfo.images.push(imageUrl);
          this.num++;
          if(this.num == this.fileNum){
            this.num = 0;
            this.fileNum = 0;
            // 这里如果 this.value.push(imageUrl) 这么写，vue会报出警告，大概意思是value作为props不应该在子组件中被修改
            // 应该根据 value 得到新的值，而不能修改它，this.value.concat(imageUrl)也是可以的，concat方法返回新的数组
            // this.$emit('input', [...this.value, imageUrl])
            this.$emit('input', this.value.concat(this.assistantInfo.images))
            this.assistantInfo.images =[];
          }
        });
      });
    },

    handlePictureCardPreview: function(file) {
      this.dialogImageUrl = file.url;
      this.dialogImgVisible = true;
    },
    handleRemove: function(file, fileList) {
      // fileList 为删除后的文件列表
      const value = fileList.map(v => v.url)
      this.assistantInfo.images = value;
      this.$emit('input', value)
    },
    handleGoodsImagesUploadSuccess(response, file, fileList) {

      if (response.code == 200) {
        let imageUrl = response.data;
        this.assistantInfo.images.push(imageUrl);
        this.num++;
        if(this.num == this.fileNum){
          this.num = 0;
          this.fileNum = 0;
          // 这里如果 this.value.push(imageUrl) 这么写，vue会报出警告，大概意思是value作为props不应该在子组件中被修改
          // 应该根据 value 得到新的值，而不能修改它，this.value.concat(imageUrl)也是可以的，concat方法返回新的数组
          // this.$emit('input', [...this.value, imageUrl])
          this.$emit('input', this.value.concat(this.assistantInfo.images))
          this.assistantInfo.images = [];
        }
      } else {
        this.$message.error(file.name + '上传失败!');
      }
    },
    handlebeforeUpload(file) {
      // 这里做可以做文件校验操作
      const isImg = /^image\/\w+$/i.test(file.type)
      if (!isImg && this.fileType == 'image/*') {
        this.$message.error('只能上传 JPG、PNG、GIF 格式!')
        return false
      }
      this.fileNum++;
    },
    handleUploadExceed() {
      this.$message.error(`最多上传${this.limit}张图片`)
    },
    //*******多图上传 结束*******

    beforeVideoUpload(file) {
      beforeVideoUpload(file);
      this.isshow = true;
    },
    videoUploadOSSRequest(file) {
      getAliyunOssToken({ dir: "video/short_video/" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.assistantInfo.video = fileUrl;
          this.isshow = false;
        });
      });
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.hides {
  background: #fff;
  width: 100px;
  height: 100px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}
</style>